import types from '../actionTypes';

export const updateImageMapOrder = meta => ({
    type: types.UPDATE_IMAGE_MAP_ORDER,
    meta,
});
